<div class="passwordPage">
    <form [formGroup]="passwordFormGroup" (ngSubmit)="resetPassword()">
        <div class="container">
            <div class="form">
                <div class="portalLogo mb-5"></div>
                <div class="text-center">
                    <h2>Reset your password</h2>
                    <p>Please <b>don't use weak and obvious passwords</b> such as
                        <i>qwerty123</i> and <i>password111</i>.
                        We strongly recommend you to use passwords with length no
                        less than 8 characters including digits, letters and
                        special symbols such as <i>!@%$#</i>.
                    </p>
                </div>
                <div class="form-group">
                    <input class="form-input" name="newPassword" id="new-password"
                        formControlName="newPassword" type="password"
                        placeholder="Enter new password"
                        [(ngModel)]="newPassword" required minlength="6"/>
                    <label for="new-password" class="form_label">Enter new password</label>
                    <div class="alert alert-danger"
                        *ngIf="passwordFormGroup.hasError('required', 'newPassword') && !passwordFormGroup.controls['newPassword']?.pristine">
                        <span>The new password is required.</span>
                    </div>
                    <div class="alert alert-danger"
                        *ngIf="passwordFormGroup.hasError('minlength', 'newPassword')">
                        The new password length should be at least 6 characters.
                    </div>
                </div>
                <div class="form-group">
                    <input class="form-input" id="confirm-password" name="confirmPassword"
                        formControlName="confirmPassword" type="password"
                        placeholder="Confirm your password"
                        [(ngModel)]="confirmPassword"/>
                    <label for="confirm-password" class="form_label">Confirm your password</label>
                    <div *ngIf="passwordFormGroup.hasError('mismatch', 'confirmPassword')"
                        class="alert alert-danger">
                        Passwords don't match.
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6 offset-6">
                        <button type="submit"
                            class="primary-button"
                            [class.disabled]='!passwordFormGroup.valid || disableButtons'
                            [disabled]="!passwordFormGroup.valid || disableButtons">
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>